import { call, put, takeEvery } from 'redux-saga/effects';

import { notificationActions } from '../../notifications/actions/notification';
import * as telephonyActions from '../actions/telephony';
import * as api from '../api/telephony';
import type { TelephonyAction } from '../constants/telephonyTypes';

const { notificationAdd } = notificationActions;

// Destructure the telephony actions.
const {
  telephonyGetAllNumbers,
  telephonyGetAllNumbersSucceeded,
  telephonyGetAllNumbersFailed,

  telephonyGetNumbersByQuery,
  telephonyGetNumbersByQuerySucceeded,
  telephonyGetNumbersByQueryFailed,

  telephonyBuyGroupNumberDelivered,

  telephonyVerifyExternalCallerId,
  telephonyVerifyExternalCallerIdSucceeded,
  telephonyVerifyExternalCallerIdFailed,
} = telephonyActions.actions;

export const telephony = [
  takeEvery(
    telephonyGetAllNumbers.toString() as any,
    genWithPromise(
      api.getAllNumbers,
      telephonyGetAllNumbersSucceeded,
      telephonyGetAllNumbersFailed,
    ),
  ),
  takeEvery(
    telephonyGetNumbersByQuery.toString() as any,
    genWithPromise(
      api.getNumbersByQuery as any,
      telephonyGetNumbersByQuerySucceeded,
      telephonyGetNumbersByQueryFailed,
    ),
  ),
  takeEvery(
    telephonyBuyGroupNumberDelivered.toString() as any,
    notifyGroupNumberDelivered,
  ),
  takeEvery(
    telephonyVerifyExternalCallerId.toString() as any,
    genWithPromiseExternal(
      api.verifyExternalCallerId,
      telephonyVerifyExternalCallerIdSucceeded,
      telephonyVerifyExternalCallerIdFailed,
    ),
  ),
];

function genWithPromise(
  apiAction: (action: TelephonyAction) => any,
  resultSucceededAction: (result: any) => any,
  resultFailedAction: (result: any) => any,
) {
  return function* (action: {
    payload: any;
    meta: { resolve: () => void; reject: () => void };
  }) {
    let result;

    try {
      result = yield call(apiAction, action.payload);
      yield call(action.meta.resolve as any, result);
      yield put(resultSucceededAction(result));
    } catch (exception) {
      console.warn(exception);
      // Something went wrong. We reject the promise.
      yield call(action.meta.reject as any, exception);
      yield put(resultFailedAction(exception));
    }
  };
}

function genWithPromiseExternal(
  apiAction: (action: TelephonyAction) => any,
  resultSucceededAction: (result: any) => any,
  resultFailedAction: (result: any) => any,
) {
  return function* (action: {
    payload: any;
    meta: { resolve: () => void; reject: () => void };
  }) {
    let result;

    const option = {
      title: `Could not verify number`,
      text: `"${action.payload.phone_number}" could not be verified as external caller id.`,
      className: 'warning',
      icon: 'i-exclamation',
      time: 10000,
    };

    try {
      result = yield call(apiAction, action.payload);
      yield call(action.meta.resolve as any, result);
      yield put(resultSucceededAction(result));
    } catch (exception) {
      console.warn(exception);
      // Something went wrong. We reject the promise.
      yield call(action.meta.reject as any, exception);
      yield put(resultFailedAction(exception));
      yield put(notificationAdd(option));
    }
  };
}

function* notifyGroupNumberDelivered(action: any) {
  let incoming = '';
  let outgoing = '';

  const option = {
    title: `${action.payload.result.data.e164_format} is ready`,
    text: '',
    className: 'success',
    type: 'newGroupDelivered',
    icon: 'i-done',
    time: 10000,
  };

  if (
    action.payload.result.status === 'incoming_functionality' ||
    action.payload.result.status === 'incoming_verified'
  ) {
    option.title += ' for incoming calls.';
    incoming = 'You can now receive incoming calls.';
    option.text = `${incoming} ${outgoing}`;
    yield put(notificationAdd(option));
  }
  if (action.payload.result.status === 'outgoing_verified') {
    option.title += ' for outgoing calls.';
    outgoing = 'You can now make outgoing calls.';
    option.text = `${incoming} ${outgoing}`;
    yield put(notificationAdd(option));
  }
}
